import { render, staticRenderFns } from "./ButtonsForImageView.vue?vue&type=template&id=c1537b98&scoped=true&"
import script from "./ButtonsForImageView.vue?vue&type=script&lang=js&"
export * from "./ButtonsForImageView.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsForImageView.vue?vue&type=style&index=0&id=c1537b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1537b98",
  null
  
)

export default component.exports